import { useTranslation } from 'react-i18next';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import useApiClient from '../../../../Shared/services/api';
import { useAppContext } from '../../../../Shared/store/appContext';
import { EndpointQueryKeys } from '../../../constants/endpoints';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';
import { deleteBooking } from '../services/service';

export const useDeleteBookingMutation = (
    setIsDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setBookingToDelete: React.Dispatch<
        React.SetStateAction<QueueSheetManagementRows | null>
    >,
    setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>,
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
) => {
    const { t } = useTranslation();
    const api = useApiClient();
    const queryClient = useQueryClient();

    const {
        state: { selectedArtEventId: artEventId },
    } = useAppContext();

    return useMutation<ApiResponseKeys, ApiError, string>({
        mutationFn: (bookingId: string) => deleteBooking(api, bookingId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [EndpointQueryKeys.GET_BOOKING_SHEET, artEventId],
            });
            setCurrentPage(0);
            setIsDeleteModalOpen(false);
            setBookingToDelete(null);
            setSuccessMessage(t('delete-booking-success-message'));
        },
    });
};
